import styled, { css } from "styled-components";
import { devices } from "../../utilities/responsive";
import firstBackgroundCareer from "../../assets/background-career-1.svg";

interface InfoProps {
  flex: boolean;
}

export const FirstBackground = styled.div`
  width: 100vw;
  height: 12.5%;
  position: absolute;
  top: -30px;
  z-index: 1;
  background-image: url(${firstBackgroundCareer});
  background-size: 200vw 100vw;
  background-position: 41% 100%;
  background-repeat: no-repeat;
  @media ${devices.phoneLg} {
    display: none;
  }
`;
export const Article = styled.div<{ IsCaseStudy: boolean }>`
  max-width: ${({ IsCaseStudy }) => (IsCaseStudy ? "90%" : "768px")};
  margin: 0 auto;
  padding-top: 0;

  h1 + p {
    font-weight: 600;
  }
  .image-inline {
    max-width: 100%;
  }

  a {
    color: var(--eyebrow-color);
    font-weight: 600;
    span {
      color: var(--eyebrow-color);
      font-weight: 600;
    }
  }

  b,
  strong {
    font-weight: 800;
  }

  blockquote {
    padding: 1em;
    border: 1px solid #fff;
    border-radius: 12px;
    margin: 4em;
  }

  blockquote p {
    font-style: italic;
  }

  blockquote cite,
  cite {
    display: block;
    line-height: 1.5;
    font-weight: bold;
    text-align: right;
  }

  .article__img {
    width: 100%;
    max-height: 700px;
    margin: 30px 0 90px;

    img {
      width: 100%;
      height: auto;
      // height: 100%;
      // object-fit: contain;
    }
  }

  .article__description {
    font-size: 2.4rem;
    line-height: 1.3;
    padding: 1em 0;
    font-weight: 300;
  }

  .article__info {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;

    @media ${devices.phoneSm} {
      padding: 0 0 10px 0;
    }

    & > * {
      @media ${devices.phoneSm} {
        margin-top: 10px;
      }
    }

    .date {
      font-size: 14px;
      font-weight: 300;
      color: var(--light-grey);
    }

    .author {
      display: flex;
      align-items: center;

      &__info {
        display: flex;
        align-items: center;

        span {
          font-size: 1.6rem;
          margin-right: 5px;
          color: var(--eyebrow-color);
        }
      }
    }
  }

  p {
    margin-top: 30px;
    word-wrap: break-word;
  }

  .social-bar {
    margin-top: 3em;
  }

  .source {
    position: absolute;
    color: var(--secondary-paragraph-color);
    font-size: 1.4rem;
    bottom: 20px;

    span {
      color: var(--primary) !important;
      font-weight: 700;
    }
  }

  .logos {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    background-color: rgba(0, 0, 0, 0.05);
  }

  video {
    width: 100%;
  }

  table {
    margin: 2rem 0;
  }

  td {
    padding: 10px;
  }

  @media only screen and (min-width: 761px) {
    table {
      border-spacing: 0;
    }
    thead {
      background: var(--eyebrow-color);
    }
    tr th,
    tr td {
      padding: 1.5rem 1rem;
    }
    tbody tr th,
    tbody tr td {
      border-bottom: 1px solid #fff;
    }
  }
  @media only screen and (min-width: 760px) {
    td {
      text-align: center;
    }
  }
  @media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    table {
      width: 100%;
    }

    table,
    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }

    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    tr {
      border: 1px solid #ccc;
    }

    td {
      border: none;
      border-bottom: 1px solid #eee;
      position: relative;
      padding-left: 50%;
    }

    td:before {
      position: absolute;
      top: 6px;
      left: 6px;
      width: 45%;
      padding-right: 10px;
      white-space: nowrap;
      content: attr(data-column);

      font-weight: bold;
    }

    tbody tr th {
      padding: 10px;
    }
  }
`;

export const ArticleInfo = styled.div<InfoProps>`
  margin-top: 3em;

  ${({ flex }) =>
    flex &&
    css`
      display: flex;
      align-items: center;
      align-content: center;
      justify-content: space-between;
      flex-wrap: wrap;
    `}
`;

export const ArticleTagsContainer = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
`;
